import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateTechStack } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateTechStack() {
  return useMutation({
    mutationFn: async ({ item, techStackId }) => {
      const payload = buildPayload(item);
      const response = await updateTechStack({ item: payload, techStackId });
      return response;
    },
    onSuccess: () => {
      toast.success("Tech Stack Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
